import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import {
  Container,
  ErrorCode,
  Title,
  Message,
  Button,
  IconContainer
} from './styles';

const AcessoNegado: React.FC = () => {
  const navigate = useNavigate();

  const voltarParaHome = () => {
    navigate('/');
  };

  return (
    <Container>
      <ErrorCode>403</ErrorCode>
      <IconContainer>
        <FaLock />
      </IconContainer>
      <Title>Acesso Negado</Title>
      <Message>
        Desculpe, você não tem permissão para acessar esta página. 
        Por favor, verifique suas credenciais ou entre em contato com o administrador do sistema.
      </Message>
      <Button onClick={voltarParaHome}>
        Voltar para a Página Inicial
      </Button>
    </Container>
  );
};

export default AcessoNegado;